// extracted by mini-css-extract-plugin
export default {"linkText":"ReadMore_linkText__QTKHS","linkTextLightTheme":"ReadMore_linkTextLightTheme__imy0P"};